export default __webpack_public_path__ + "static/media/Maniacal Harm.e38d1c55.jpg";